import React from 'react';

const Award = () => {
  return <div />;
};

export default Award;
